<template>
    <rkm-row>
        <rkm-col cols="12">

            <rkm-area
                class="mb-2"
                type="fieldset"
                title="Horários disponíveis"
            >

                <rkm-form ref="Form">
                    <rkm-form-radio-group
                        v-model="horario"
                        name="Horário"
                        :options="horariosDisponiveis"
                        :validations="validations.horario"
                        @change="$emit('handleAgendamento', exames, horario)"
                    />
                </rkm-form>
            </rkm-area>

            <rkm-area
                class="mb-2"
                type="fieldset"
                title="Exames solicitados"
            >
                 <rkm-form ref="RkmForm">

                     <rkm-row class="flex-nowrap">
                        <rkm-col
                            v-if="hasKitsExames() && !isFromRegulacao"
                            class="rkm-col"
                            cols="3"
                        >
                        <rkm-area
                            title="Kit de Exames"
                            type="section"
                        >
                            <rkm-form-checkbox
                                v-for="(kit, i) in data.form.kits"
                                v-bind:key="`rkm-form-checkbox-kit-${i}`"
                                :class="'rkm-form-checkbox' + (i === data.form.kits.length - 1 ? '' : ' mb-1')"
                                :id="'popover-' + i"
                                :indeterminate="handleIndeterminate(kit)"
                                @change.native="handleKitChange($event, kit)"
                                v-model="kit.checked"
                            >
                                {{ kit.nome }}
                            </rkm-form-checkbox>

                            <rkm-popover
                                v-for="(kit, i) in data.form.kits"
                                v-bind:key="i"
                                :target="'popover-' + i"
                                triggers="hover"
                            >
                                <div class="rkm-popover">
                                    <rkm-form-checkbox
                                        v-for="(exame, j) in kit.exames"
                                        v-bind:key="`rkm-form-checkbox-exame-${j}`"
                                        :class="'rkm-form-checkbox' + (j === kit.exames.length - 1 ? '' : ' mb-1')"
                                        v-model="exame.checked"
                                        @change.native="handleItemKitChange($event, exame)"
                                    >
                                        {{ exame.nome }}
                                    </rkm-form-checkbox>
                                </div>
                            </rkm-popover>
                        </rkm-area>
                        </rkm-col>

                        <rkm-col :cols="hasKitsExames() && !isFromRegulacao ? 9 : 12">
                            <rkm-row v-if="!isFromRegulacao">
                                <rkm-col cols="8">
                                    <rkm-form-input-autocomplete
                                        :request-query-string-params="autocompletesRequestParams.exame.queryString"
                                        :repository="repositories.exame"
                                        :searchFields="fields.autocompletes.exame"
                                        :text-field="e => e.codigo ? `${e.codigo} - ${e.nome}` : `${e.nome}`"
                                        :validations="validations.exame"
                                        label="Exame"
                                        v-model="exame"
                                    />
                                </rkm-col>
                                <rkm-col cols="4">
                                    <rkm-button
                                        :label="false"
                                        color="primary"
                                        @click.stop="handleAdd"
                                    >
                                        Incluir
                                    </rkm-button>
                                    <rkm-button
                                        :label="false"
                                        @click.stop="resetForm"
                                    >
                                        Limpar
                                    </rkm-button>
                                </rkm-col>
                            </rkm-row>
                            <rkm-row>
                                <rkm-col>
                                    <rkm-list
                                        :items="exames"
                                        hide-filters
                                        hide-pagination
                                    >
                                        <template v-slot="{ item }">
                                            {{ item.nome }}
                                        </template>

                                        <template v-slot:trailling="{ item }">
                                            <rkm-button
                                                v-if="!isFromRegulacao"
                                                @click.stop="deleteExame(item)"
                                                color="danger"
                                                title="Excluir"
                                                small
                                            >
                                                <rkm-icon icon="trash" />
                                            </rkm-button>
                                        </template>
                                    </rkm-list>
                                </rkm-col>
                            </rkm-row>
                        </rkm-col>

                    </rkm-row>
                </rkm-form>


                <ModalPermissao
                    ref="RkmModalPermissao"
                    @saveModal="saveModal"
                    @handleExitSupervisor="handleExitSupervisor"
                    :origem="origem"
                />
            </rkm-area>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

//Enums
import tipoJornada from '@/enums/exame-laboratorial/tipoJornada'
import tipoExame from '@/enums/parametrizacao/tipoExame'
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'
import motivo from '@/enums/exame-laboratorial/motivo'
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'

// Moment.
import moment from 'moment'

// Components.
import ModalPermissao from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/permissao/Modal'

export default {
    components: {
        ModalPermissao
    },
    computed: {
        validations() {

            return {
                exame: { required: true },
                horario: { required: true },
            }
        },
        autocompletesRequestParams() {

            return {
                exame: {
                    queryString: {
                        tipo_id: this.enums.tipoExame.EXAME_LABORATORIAL,
                        paciente_id: this.paciente.id,
                        classificacao_id: this.paciente.classificacaoId,
                    }
                }
            }
        },
        horariosDisponiveis() {

            let horarios = []

            this.jornadas.filter(item => item.data === this.itemSelecionado.data).map(horario => {

                let vagas = horario.vagas

                let horarioInicial = horario.horaInicial

                let tempoAtendimento = horario.tempoAtendimento

                let selecionado = this.horarioSelecionado.filter(h => h.horaInicial == horarioInicial).length ?? 0

                if (horario.tipoId == this.enums.tipoJornada.DINAMICA) {

                    horarioInicial = moment(horarioInicial, "HH:mm")
                        .subtract(tempoAtendimento, 'minutes')
                        .format('HH:mm');

                    for (let i = 0; i < vagas; i++) {

                        if (i !== this.tabIndex) {

                            horarioInicial = moment(horarioInicial, "HH:mm")
                                .add(tempoAtendimento, 'minutes')
                                .format('HH:mm');

                            selecionado = this.horarioSelecionado.filter(h => h.horaInicial == horarioInicial).length ?? 0

                            horarios.push({text: horarioInicial + ' - ' + selecionado + '/1', value: horarioInicial})
                        }
                    }
                } else {

                    horarios.push({text: horarioInicial + ' - ' + selecionado + '/' + vagas, value: horarioInicial})
                }
            })

            this.$emit('horariosDisponiveis', horarios)

            return horarios
        },
        fields() {

            return {
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        isFromRegulacao() {

            return !!this.regulacaoSolicitacao
        },
    },
    created() {
        this.repositories = {
            feriado: this.getConectaSusRepository('cadastro.feriado.feriado'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        }

        this.load()
    },
    data: () => ({
        exame: null,
        examesBarrados: [],
        autoriza: false,
        origem: 'exame',
        exames: [],
        selecionado: {},
        newIndex: null,
        cadastro: [],
        horario: null,
        dataInformada: null,
        horaInicial: null,
        verifyExame: false,
        horarioSelecionado: [],
        enums: {
            tipoJornada,
            tipoExame,
            tipoCota,
            tipoUnidade,
            motivo,
            statusAgendamento
        },
        cotaExame: [],
        saldoExame: {
            quantidade: 0,
            utilizada: 0,
            utilizadaValor: 0,
            saldoQuantidade: 0,
            saldoValor: 0,
            valor: 0,
        },
        cotaExameQuantidade: false,
        cotaExameValor: false,
        supervisorId: null,
        exameBloqueado: {
            exameId: null,
            pacienteId: null,
            valor: null,
            motivoId: null,
        },
        examesBloqueado: [],
        regulacao: {
            examesComCadastroIncompleto: [],
            examesComCotaAtingida: [],
            examesComCotaExameAtingida: [],
            mensagemExames: '',
            mensagemLimiteAnual: '',
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.agendamento.incluido.length > 0) {

                this.agendamento.incluido.forEach(exame => {

                    this.exames.push(exame)
                })
            }

            if (this.agendamento.horaInicial) {

                this.horario = this.agendamento.horaInicial
            }

            this.horarioSelecionado = this.vagas.filter(h => h.data == this.itemSelecionado.data)
        },
        validate() {

            return this.$refs.Form.validate()
        },
        addExamesRegulados() {

            if (this.exames.length > 0) return

            this.regulacao.examesComCadastroIncompleto = []
            this.regulacao.examesComCotaAtingida = []
            this.regulacao.examesComCotaExameAtingida = []
            this.regulacao.mensagemExames = ''
            this.regulacao.mensagemLimiteAnual = ''

            this.supervisorId = null

            this.regulacaoSolicitacao.itens.forEach(({ exame }) => {

                if (!exame.siglaExame || !exame.grupoTipoId) {

                    this.regulacao.examesComCadastroIncompleto.push(exame)

                    return
                }

                if (this.handleCota(exame)) {

                    if (this.autoriza == false && this.verificaAutorizacao == false) {

                        this.saveExameBloqueado(this.enums.motivo.COTA, exame)

                        this.regulacao.examesComCotaAtingida.push(exame)

                        return
                    }
                    else {

                        this.saveExameBloqueado(this.enums.motivo.COTA, exame)

                        this.supervisorId = this.agendamento.supervisorId
                    }
                }

                if (this.handleCotaExame(exame)) {

                    if (this.autoriza == false && this.verificaAutorizacao == false) {

                        this.saveExameBloqueado(this.enums.motivo.COTA_EXAME, exame)

                        this.regulacao.examesComCotaExameAtingida.push(exame)

                        return
                    }
                    else {

                        this.saveExameBloqueado(this.enums.motivo.COTA_EXAME, exame)

                        this.supervisorId = this.agendamento.supervisorId
                    }
                }

                this.verifyExame = false

                let msgExame = ''
                let msgLimiteAnual = ''

                this.data.model.agendamentos
                    .filter(e => e.pacienteId == this.paciente.id && e.agendamentoId !== this.agendamento.agendamentoId)
                    .forEach(exameIncluido => {

                        let exameFind = exameIncluido.incluido.find(m => m.codigo == exame.codigo)

                        if (exameFind) {

                            if (exame.validade !== null
                                && exameFind.statusId != this.enums.statusAgendamento.FALTOU
                                && exameFind.statusId != this.enums.statusAgendamento.NAO_REALIZADO
                            ) {

                                let addDay = moment(exameIncluido.data).add(exame.validade, 'days').format('YYYY-MM-DD')

                                if  (moment(addDay).isAfter(this.data.form.dataAtual.split("/").reverse().join("-"))) {

                                    if (this.autoriza == false && this.verificaAutorizacao == false) {

                                        this.dataInformada = exameIncluido.data.split("-").reverse().join("/")
                                        this.horaInicial = exameIncluido.horaInicial.split("-").reverse().join("/")

                                        if (msgExame) {

                                            msgExame = msgExame.concat(`, <strong>${this.dataInformada}</strong>
                                                às <strong>${this.horaInicial}</strong>`)
                                        }
                                        else {

                                            msgExame = msgExame.concat(`O paciente já possui agendamento para o
                                                exame <strong>${exame.nome}</strong> dentro do prazo de
                                                validade, na(s) seguinte(s) data(s):
                                                <strong>${this.dataInformada}</strong> às
                                                <strong>${this.horaInicial}</strong>`)
                                        }

                                        this.verifyExame = true
                                    }
                                    else {

                                        this.saveExameBloqueado(this.enums.motivo.PRAZO_VALIDADE, exame)

                                        this.supervisorId = this.agendamento.supervisorId
                                    }
                                }
                            }

                            let quantidadeMaxima = exame.quantidadeMaxima ?? exame.quantidadeMaximaExecucao

                            if (quantidadeMaxima !== null && quantidadeMaxima !== 9999) {

                                let meses = 12/quantidadeMaxima
                                let addMeses = moment(exameIncluido.data).add(meses, 'months').format('YYYY-MM-DD')

                                if (moment(addMeses).isAfter(this.data.form.dataAtual.split("/").reverse().join("-"))) {

                                    if (this.autoriza == false && this.verificaAutorizacao == false) {

                                        this.dataInformada = exameIncluido.data.split("-").reverse().join("/")
                                        this.horaInicial = exameIncluido.horaInicial.split("-").reverse().join("/")

                                        if (msgExame) {

                                            msgExame = msgExame.concat(`, <strong>${this.dataInformada}</strong>
                                                às <strong>${this.horaInicial}</strong>`)
                                        }
                                        else {

                                            msgExame = msgExame.concat(`O paciente já possui agendamento para o
                                                exame <strong>${exame.nome}</strong> dentro do prazo de
                                                validade, na(s) seguinte(s) data(s):
                                                <strong>${this.dataInformada}</strong> às
                                                <strong>${this.horaInicial}</strong>`)
                                        }

                                        this.verifyExame = true
                                    }
                                    else {

                                        this.saveExameBloqueado(this.enums.motivo.PRAZO_VALIDADE, exame)

                                        this.supervisorId = this.agendamento.supervisorId
                                    }
                                }

                                let quantidadeExameAgendado = 0

                                this.data.model.agendamentos
                                    .filter(e => e.pacienteId == this.paciente.id
                                        && e.agendamentoId !== this.agendamento.agendamentoId)
                                    .forEach(exameIncluido => {

                                        if(exameIncluido.incluido.find(m => m.codigo == exame.codigo)){

                                            quantidadeExameAgendado = quantidadeExameAgendado + 1
                                        }
                                    })

                                if (quantidadeMaxima <= quantidadeExameAgendado) {

                                    if (this.autoriza == false && this.verificaAutorizacao == false) {

                                        msgLimiteAnual = `O paciente já atingiu o limite anual para o exame
                                            <strong>${exame.nome}</strong>.`

                                        this.verifyExame = true
                                    }
                                    else {

                                        this.saveExameBloqueado(this.enums.motivo.LIMITE_ANUAL, exame)

                                        this.supervisorId = this.agendamento.supervisorId
                                    }
                                }
                            }
                        }
                    })

                if (this.verifyExame) {

                    if (msgLimiteAnual) {

                        this.saveExameBloqueado(this.enums.motivo.LIMITE_ANUAL, exame)
                    }
                    else {

                        this.saveExameBloqueado(this.enums.motivo.PRAZO_VALIDADE, exame)
                    }

                    if (msgExame) {

                        msgExame = msgExame.concat('.')

                        this.regulacao.mensagemExames = this.regulacao.mensagemExames
                            ? this.regulacao.mensagemExames.concat(`<br><br>${msgExame}`)
                            : msgExame
                    }

                    if (msgLimiteAnual) {

                        this.regulacao.mensagemLimiteAnual = this.regulacao.mensagemLimiteAnual
                            ? this.regulacao.mensagemLimiteAnual.concat(`<br>${msgLimiteAnual}`)
                            : msgLimiteAnual
                    }

                    return
                }
            })

            if (this.regulacao.examesComCadastroIncompleto.length > 0) {

                const exames = this.regulacao.examesComCadastroIncompleto.map(e => e.nome)

                this.showAlert(`Para adicionar o(s) exame(s) abaixo é necessário que todas as informações
                    obrigatórias estejam preenchidas. Acesse Parametrização > Exame e preencha as informações.<br><br>
                    ${exames.join('<br>')}`
                , 'Atenção')

                this.$emit('handleExit')

                return
            }

            if (this.regulacao.examesComCotaAtingida.length > 0) {

                const exames = this.regulacao.examesComCotaAtingida.map(e => e.nome)

                this.showConfirmation(
                    `A cota para o(s) exame(s) abaixo foi atingida, para continuar é necessário
                    informar os dados do supervisor.<br><br>
                    ${exames.join('<br>')}<br><br>
                    Deseja continuar?`,
                    async () => this.$refs.RkmModalPermissao.open(),
                    async () => this.$emit('handleExit')
                )

                return
            }

            if (this.regulacao.examesComCotaExameAtingida.length > 0) {

                const exames = this.regulacao.examesComCotaExameAtingida.map(e => e.nome)

                this.showConfirmation(
                    `Cota de exame(s) abaixo foi atingida, para continuar é necessário informar os dados do supervisor.<br><br>
                    ${exames.join('<br>')}<br><br>
                    Deseja continuar?`,
                    async () => this.$refs.RkmModalPermissao.open(),
                    async () => this.$emit('handleExit')
                )

                return
            }

            if (this.regulacao.mensagemExames || this.regulacao.mensagemLimiteAnual) {

                if (this.regulacao.mensagemExames) {

                    this.regulacao.mensagemExames = this.regulacao.mensagemExames.concat(`<br><br>`)
                }

                if (this.regulacao.mensagemLimiteAnual) {

                    this.regulacao.mensagemLimiteAnual = this.regulacao.mensagemLimiteAnual.concat(`<br><br>`)
                }

                this.showConfirmation(
                    `${this.regulacao.mensagemExames} ${this.regulacao.mensagemLimiteAnual} Para continuar é
                        necessário informar os dados do supervisor. Deseja continuar?`,
                    async () => this.$refs.RkmModalPermissao.open(),
                    async () => this.$emit('handleExit')
                )

                return
            }

            this.regulacaoSolicitacao.itens.forEach(({ exame }) => {

                const param = {
                    id: this.uniqueId('exame' + new Date().getTime()),
                    checked: true,
                    exameId: exame.id,
                    nome: exame.nome,
                    codigo: exame.codigo,
                    supervisorId: this.supervisorId,
                    observacao: exame.observacao,
                    prazoEntrega: exame.prazoEntrega,
                    procedimentoId: exame.procedimentoId,
                    valor: exame.valorSigtap ? exame.valorServicoAmbilatorial : exame.valor
                }

                this.exames.push(this.clone(this.prepareExame(param)))
            })

            this.$emit('handleAgendamento', this.exames, this.horario)
        },
        handleAdd() {

            this.$refs.RkmForm.validate().then(valid => {

                if (!valid) return

                this.supervisorId = null

                if(this.hasExameParametrizadoNome(this.exame.nome)){

                    this.resetForm()
                    this.showAlert('Exame já cadastrado no agendamento.', 'Atenção')
                    return
                }

                if (this.hasExameParametrizado(this.exame.codigo)) {

                    if(this.exame.codigo != ''){
                        this.resetForm()
                        this.showAlert('Exame já cadastrado no agendamento.', 'Atenção')
                        return
                    }
                }

                if (!this.exame.siglaExame || !this.exame.grupoTipoId) {

                    this.resetForm()
                    this.showAlert(`Para selecionar este exame, é necessário que todas as informações obrigatórias
                        estejam preenchidas. Acesse Parametrização > Exame e preencha as informações.` , 'Atenção')

                    return
                }

                if (this.handleCota()) {

                    if (this.autoriza == false && this.verificaAutorizacao == false) {
                        this.saveExameBloqueado(this.enums.motivo.COTA)

                        const confirm = async () => {

                            this.$refs.RkmModalPermissao.open()

                            return false
                        }

                        const cancel = async () => { this.$emit('handleExit') }

                        const msg = 'A cota foi atingida, para continuar é necessário informar' +
                            ' os dados do supervisor. Deseja continuar?'

                        this.showConfirmation(msg, confirm, cancel)

                        return false
                    } else {

                        this.saveExameBloqueado(this.enums.motivo.COTA)

                        this.supervisorId = this.agendamento.supervisorId
                    }
                }

                if (this.handleCotaExame()) {

                    if (this.autoriza == false && this.verificaAutorizacao == false) {

                        this.saveExameBloqueado(this.enums.motivo.COTA_EXAME)

                        const confirm = async () => {

                            this.$refs.RkmModalPermissao.open()

                            return false
                        }

                        const cancel = async () => { this.$emit('handleExit') }

                        const msg = 'Cota de exame foi atingida, para continuar é necessário informar' +
                            ' os dados do supervisor. Deseja continuar?'

                        this.showConfirmation(msg, confirm, cancel)

                        return false

                    } else {

                        this.saveExameBloqueado(this.enums.motivo.COTA_EXAME)

                        this.supervisorId = this.agendamento.supervisorId
                    }
                }

                this.data.form.kits.map(k => k.exames.map(e => e.id === this.exame.id && (e.checked = true)))

                this.$nextTick().then(() => this.add())
            })
        },
        async handleAddKit() {
            if(this.hasExameParametrizadoNome(this.exame.nome)){
                return
            }

            if (this.hasExameParametrizadoCodigoNome(this.exame)) {

                if(this.exame.codigo != ''){
                    return
                }
            }

            if (!this.exame.siglaExame || !this.exame.grupoTipoId) {
                return
            }

            if (this.handleCota()) {
                if (this.autoriza == false && this.verificaAutorizacao == false) {

                    this.saveExameBloqueado(this.enums.motivo.COTA)

                    const confirm = async () => {

                        this.$refs.RkmModalPermissao.open()

                        return false
                    }

                    const cancel = async () => { this.$emit('handleExit') }

                    const msg = 'A cota foi atingida, para continuar é necessário informar' +
                        ' os dados do supervisor. Deseja continuar?'

                    this.showConfirmation(msg, confirm, cancel)

                    return false

                } else {
                    this.saveExameBloqueado(this.enums.motivo.COTA)
                    this.supervisorId = this.agendamento.supervisorId
                }
            }

            if (this.handleCotaExame()) {
                if (this.autoriza == false && this.verificaAutorizacao == false) {

                    this.saveExameBloqueado(this.enums.motivo.COTA_EXAME)

                    const confirm = async () => {

                        this.$refs.RkmModalPermissao.open()

                        return false
                    }

                    const cancel = async () => { this.$emit('handleExit') }

                    const msg = 'Cota de exame foi atingida, para continuar é necessário informar' +
                        ' os dados do supervisor. Deseja continuar?'

                    this.showConfirmation(msg, confirm, cancel)

                    return false

                } else {
                    this.saveExameBloqueado(this.enums.motivo.COTA_EXAME)
                    this.supervisorId = this.agendamento.supervisorId
                }
            }

            this.data.form.kits.map(k => k.exames.map(e => e.id === this.exame.id && (e.checked = true)))

            const exameadicionado = this.add(true);

            if(exameadicionado.msgExame || exameadicionado.msgLimiteAnual) {
                const result = await new Promise((resolve) => {
                    const confirm = async () => {
                        await this.$refs.RkmModalPermissao.open();
                        resolve(true);
                    };

                    const cancel = async () => {
                        this.$emit('handleExit');

                        for (const key in exameadicionado) {
                            if (Object.prototype.hasOwnProperty.call(exameadicionado, key)) {
                                delete exameadicionado[key];
                            }
                        }

                        resolve(false);
                    };

                    const msg = `${exameadicionado.msgExame} ${exameadicionado.msgLimiteAnual} Para continuar é necessário informar os dados do supervisor. Deseja continuar?`;

                    this.showConfirmation(msg, confirm, cancel);
                });

                if(result) {
                    this.examesBarrados.map(e => {
                        if (this.newIndex !== null) {
                            this.$set(this.exames, this.newIndex, this.clone(this.prepareExame(e)))
                        } else {
                            this.exames.push(this.clone(this.prepareExame(e)))
                        }

                        this.$emit('handleAgendamento', this.exames, this.horario)
                    })
                    this.examesBarrados = null;
                }
            }

            if(exameadicionado.exame) {
                if (this.newIndex !== null) {
                    this.$set(this.exames, this.newIndex, this.clone(this.prepareExame(exameadicionado.exame)))
                } else {
                    this.exames.push(this.clone(this.prepareExame(exameadicionado.exame)))
                }

                this.$emit('handleAgendamento', this.exames, this.horario)
            }

            this.resetForm();

        },
        add(adicionadoPorKit = false) {
            this.verifyExame = false

            let msgExame = ''
            let msgLimiteAnual = ''

            this.data.model.agendamentos.filter(e => e.pacienteId == this.paciente.id &&
                e.agendamentoId !== this.agendamento.agendamentoId)
                    .forEach(exameIncluido => {

                        if (this.exame) {

                            let exameFind = exameIncluido.incluido.find(m => m.codigo == this.exame.codigo);
                            if(exameFind){
                                if (this.exame.validade !== null && exameFind.statusId != this.enums.statusAgendamento.FALTOU && exameFind.statusId != this.enums.statusAgendamento.NAO_REALIZADO) {

                                    let addDay = moment(exameIncluido.data).add(this.exame.validade, 'days').format('YYYY-MM-DD')

                                    if  (moment(addDay).isAfter(this.data.form.dataAtual.split("/").reverse().join("-"))) {

                                        if (this.autoriza == false && this.verificaAutorizacao == false) {

                                            this.dataInformada = exameIncluido.data.split("-").reverse().join("/")
                                            this.horaInicial = exameIncluido.horaInicial.split("-").reverse().join("/")

                                            if (msgExame) {

                                                msgExame = msgExame.concat(`, <strong>${ this.dataInformada }</strong>
                                                    às <strong>${this.horaInicial}</strong>`)
                                            } else {

                                                msgExame = msgExame.concat(`O paciente já possui agendamento para o
                                                    exame <strong>${ this.exame.nome}</strong> dentro do prazo de
                                                    validade, na(s) seguinte(s) data(s):
                                                    <strong>${ this.dataInformada }</strong> às
                                                    <strong>${this.horaInicial}</strong>`)
                                            }

                                            this.verifyExame = true
                                        } else {

                                            this.saveExameBloqueado(this.enums.motivo.PRAZO_VALIDADE)

                                            this.supervisorId = this.agendamento.supervisorId
                                        }
                                    }
                                }

                                let quantidadeMaxima = this.exame.quantidadeMaxima ?? this.exame.quantidadeMaximaExecucao

                                if (quantidadeMaxima !== null && quantidadeMaxima !== 9999) {

                                    let meses = 12/quantidadeMaxima
                                    let addMeses = moment(exameIncluido.data).add(meses, 'months').format('YYYY-MM-DD')

                                    if (moment(addMeses).isAfter(this.data.form.dataAtual.split("/").reverse().join("-"))) {

                                        if (this.autoriza == false && this.verificaAutorizacao == false) {

                                            this.dataInformada = exameIncluido.data.split("-").reverse().join("/")
                                            this.horaInicial = exameIncluido.horaInicial.split("-").reverse().join("/")

                                            if (msgExame) {

                                                msgExame = msgExame.concat(`, <strong>${ this.dataInformada }</strong>
                                                    às <strong>${this.horaInicial}</strong>`)
                                            } else {

                                                msgExame = msgExame.concat(`O paciente já possui agendamento para o
                                                    exame <strong>${ this.exame.nome}</strong> dentro do prazo de
                                                    validade, na(s) seguinte(s) data(s):
                                                    <strong>${ this.dataInformada }</strong> às
                                                    <strong>${this.horaInicial}</strong>`)
                                            }

                                            this.verifyExame = true
                                        } else {

                                            this.saveExameBloqueado(this.enums.motivo.PRAZO_VALIDADE)

                                            this.supervisorId = this.agendamento.supervisorId
                                        }
                                    }
                                }

                                if (quantidadeMaxima !== null && quantidadeMaxima !== 9999) {

                                    let quantidadeExameAgendado = 0

                                    this.data.model.agendamentos.filter(e => e.pacienteId == this.paciente.id &&
                                        e.agendamentoId !== this.agendamento.agendamentoId).forEach(exameIncluido => {

                                            if(exameIncluido.incluido.find(m => m.codigo == this.exame.codigo)){

                                                quantidadeExameAgendado = quantidadeExameAgendado + 1
                                            }
                                        })

                                    if (quantidadeMaxima <= quantidadeExameAgendado) {

                                        if (this.autoriza == false && this.verificaAutorizacao == false) {

                                            msgLimiteAnual = `O paciente já atingiu o limite anual para o exame
                                                <strong>${ this.exame.nome}</strong>.<br><br>`

                                            this.verifyExame = true
                                        } else {

                                            this.saveExameBloqueado(this.enums.motivo.LIMITE_ANUAL)

                                            this.supervisorId = this.agendamento.supervisorId
                                        }
                                    }
                                }
                            }
                        }
                    })

            if (this.verifyExame) {

                if (msgLimiteAnual) {

                    this.saveExameBloqueado(this.enums.motivo.LIMITE_ANUAL)
                } else {

                    this.saveExameBloqueado(this.enums.motivo.PRAZO_VALIDADE)
                }

                if (msgExame) {

                    msgExame = msgExame.concat(`.<br><br>`)
                }

                if(adicionadoPorKit) {
                    this.examesBarrados.push(this.exame);
                    return { msgExame, msgLimiteAnual };
                }

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()

                    return false
                }

                const cancel = async () => { this.$emit('handleExit') }

                const msg = `${ msgExame } ${ msgLimiteAnual } Para continuar é necessário informar os dados do
                    supervisor. Deseja continuar?`

                this.showConfirmation(msg, confirm, cancel)

            } else {

                const param = {
                    id: this.uniqueId('exame' + new Date().getTime()),
                    checked: true,
                    exameId: this.exame.id,
                    nome: this.exame.nome,
                    codigo: this.exame.codigo,
                    supervisorId: this.supervisorId,
                    observacao: this.exame.observacao,
                    prazoEntrega: this.exame.prazoEntrega,
                    procedimentoId: this.exame.procedimentoId,
                    valor: this.exame.valorSigtap ? this.exame.valorServicoAmbilatorial : this.exame.valor
                }

                if(adicionadoPorKit) {
                    return { "exame": param };
                }

                if (this.newIndex !== null) {

                    this.$set(this.exames, this.newIndex, this.clone(this.prepareExame(param)))
                } else {

                    this.exames.push(this.clone(this.prepareExame(param)))
                }
                this.$emit('handleAgendamento', this.exames, this.horario)

                this.resetForm()
            }
        },
        hasExameParametrizado(exameParametrizado) {

            return this.exames.find(exame => exame.codigo === exameParametrizado)
        },
        hasExameParametrizadoNome(exameParametrizadoNome) {

            return this.exames.find(exame => exame.nome === exameParametrizadoNome)
        },
        hasExameParametrizadoCodigoNome(exameParametrizadoCodigoNome) {
            return this.exames.find(exame => exame.codigo === exameParametrizadoCodigoNome.codigo && exame.nome === exameParametrizadoCodigoNome.nome)
        },
        resetForm() {

            this.exame = null
            this.$nextTick(() => this.$refs.RkmForm.resetValidator())
        },
        handleExitSupervisor() {

            this.$emit('handleExit')
        },
        deleteExame(item) {

            const objId = this.exames.findIndex((obj => (obj.id == item.id) || obj.id == item.exameId));

            const destroy = async () => {

                this.exames.splice(objId, 1)
                this.data.form.kits.map(k => k.exames.map(e => ((e.id === item.id) || (e.id === item.exameId)) && (e.checked = false)))
                this.$emit('handleAgendamento', this.exames, this.horario)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir o exame <strong>${ item.nome }</strong> da lista?`,
                destroy)
        },
        handleCota(exame = null) {

            if (!exame) {

                exame = this.exame
            }

            let valorTotalExame = 0
            let valorExame = 0

            if (exame) {

                valorExame = exame.valorSigtap ? exame.valorServicoAmbilatorial : exame.valor
            }

            if (this.exames.length > 0) {

                this.exames.map(e => {

                    valorTotalExame += parseFloat(e.valor)
                })

                valorTotalExame += parseFloat(valorExame)
            }

            if (this.cota.laboratorioQuantidade && this.cota.laboratorioQuantidade.saldo <= 0) {

                return true
            }

            if (this.cota.laboratorioValor) {

                if (this.cota.laboratorioValor.saldo <= 0
                    || this.formatSumMoney(this.formatMoney(this.cota.laboratorioValor.saldo, 2)) < valorExame
                    || this.formatSumMoney(this.formatMoney(this.cota.laboratorioValor.saldo, 2)) <= valorTotalExame
                ) {

                    return true
                }
            }

            if (this.cota.unidadeSolicitanteQuantidade && this.cota.unidadeSolicitanteQuantidade.saldo <= 0) {

                return true
            }

            if (this.cota.unidadeSolicitanteValor) {

                if (this.cota.unidadeSolicitanteValor.saldo <= 0
                    || this.formatSumMoney(this.formatMoney(this.cota.unidadeSolicitanteValor.saldo, 2)) < valorExame
                    || this.formatSumMoney(this.formatMoney(this.cota.unidadeSolicitanteValor.saldo, 2)) <= valorTotalExame
                ) {

                    return true
                }
            }

            return false
        },
        handleCotaExame(exame = null) {

            let valorExame = null
            let exameId = null

            if (exame) {

                if (this.isFromRegulacao) {

                    valorExame = exame.valorSigtap ? exame.valorServicoAmbilatorial : exame.valor
                    exameId = exame.id
                }
                else {

                    valorExame = exame.valor
                    exameId = exame.exameId
                }
            }
            else {

                valorExame = this.exame && this.exame.valorSigtap ? this.exame.valorServicoAmbilatorial : this.exame.valor
                exameId = this.exame.id
            }

            if (this.cota.exameQuantidade) {

                let exameQuantidade = this.cota.exameQuantidade.find(e => e.exameId === exameId)

                if (exameQuantidade && exameQuantidade.saldo <= 0) {

                    return true
                }
            }

            if (this.cota.exameValor) {

                let exameValor = this.cota.exameValor.find(e => e.exameId === exameId)

                if (exameValor && exameValor.saldo < valorExame) {

                    return true
                }
            }

            if (this.cota.examePeriodoQuantidade) {

                let examePeriodoQuantidade = this.cota.examePeriodoQuantidade.find(e => e.exameId === exameId)

                if (examePeriodoQuantidade && examePeriodoQuantidade.saldo && examePeriodoQuantidade.saldo <= 0) {

                    return true
                }
            }

            if (this.cota.examePeriodoValor) {

                let examePeriodoValor = this.cota.examePeriodoValor.find(e => e.exameId === exameId)

                if (examePeriodoValor && examePeriodoValor.saldo && examePeriodoValor.saldo < valorExame) {

                    return true
                }
            }

            return false
        },
        handleAlterCota() {

            if (this.autoriza == false && this.verificaAutorizacao == false && this.handleCota()) {

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()

                    return false
                }

                const cancel = async () => { this.$emit('handleExit') }

                const msg = 'Cota foi atingida, para continuar é necessário informar' +
                    ' os dados do supervisor. Deseja continuar?'

                this.showConfirmation(msg, confirm, cancel)

                return false
            }

            this.agendamento.incluido.forEach(exame => {

                if (this.autoriza == false && this.verificaAutorizacao == false && this.handleCotaExame(exame)) {

                    const confirm = async () => {

                        this.$refs.RkmModalPermissao.open()

                        return false
                    }

                    const cancel = async () => { this.$emit('handleExit') }

                    const msg = 'Cota de exame foi atingida, para continuar é necessário informar' +
                        ' os dados do supervisor. Deseja continuar?'

                    this.showConfirmation(msg, confirm, cancel)

                    return false
                }
            })
        },
        saveModal(supervisorId){

            this.agendamento.supervisorId = supervisorId
            this.autoriza = true

            this.$emit('handleAutoriza')

            if (this.isFromRegulacao) {

                this.addExamesRegulados()
            }
            else if (this.exame) {

                this.handleAdd()
            }
        },
        saveExameBloqueado(motivo, exame = null) {

            if (!exame) {

                exame = this.exame
            }

            const exameExistente = this.examesBloqueado.find(exame => exame.exameId ===  exame.id);

            if (!exameExistente) {

                this.repositories.agendamento.saveExameBloqueado(this.prepareData(motivo, exame))
                    .then(({ data }) => {

                        this.examesBloqueado.push(data);
                    })
                    .catch(this.handleError)
                    .finally()
            }
        },
        prepareData(motivo, exame) {

            const exameBloqueado = this.clone(this.exameBloqueado)

            exameBloqueado.pacienteId = this.paciente.id
            exameBloqueado.exameId = exame.id
            exameBloqueado.valor = exame.valorSigtap ? exame.valorServicoAmbilatorial : exame.valor
            exameBloqueado.motivoId = motivo

            return this.camelObjectKeysToSnakeRecursive(exameBloqueado)
        },
        handleHorario(horarios) {

            const horario = horarios.find(h => h.value == this.horario)

            if (!horario) {
                this.horario = null
            }
        },
        hasKitsExames() {
            return this.data.form.kits.length > 0
        },
        handleIndeterminate(kit) {
            const indeterminate = kit.exames.some(exameKit => {
                return !!this.exames.find(examePedido => (examePedido.id === exameKit.id) || (examePedido.exameId === exameKit.id))
            })

            const checked = kit.exames.every(exameKit => {
                return !!this.exames.find(examePedido => (examePedido.id === exameKit.id) || (examePedido.exameId === exameKit.id))
            })

            if (indeterminate === true && checked === false) {
                return true
            }

            kit.checked = checked

            return false
        },
        async handleItemKitChange(event, exame) {
            const { checked } = event.target

            if (checked) {
                this.exame = exame;
                await this.handleAddKit();
            }
            else {

                exame.checked = false

                const index = this.exames.findIndex(e => ((e.id === exame.id) || (e.id === exame.exameId)))

                this.exames.splice(index, 1)
            }
        },
        prepareExame(exameKit) {

            const exame = this.clone(exameKit)

            exame.dataSolicitacao = ''

            delete exame.checked

            return exame
        },
        handleKitChange(event, kit) {

            const { checked } = event.target

            if (checked) {
                kit.exames.map(async exame => {
                    if (!this.exames.find(e => (e.id === exame.id) || (e.exameId === exame.id))) {

                        this.exame = exame
                        await this.handleAddKit()
                    }
                })
            }
            else {

                kit.exames.map(exame => {

                    const index = this.exames.findIndex(e => (e.id === exame.id) || (e.exameId === exame.id))

                    if (index >= 0) {

                        exame.checked = false

                        this.exames.splice(index, 1)
                    }
                })
            }
        },
    },
    mixins: [ repository, stringCase, object, formats ],
    props: {
        data: { type: Object, required: true},
        itemSelecionado: { type: Object, required: true },
        paciente: { type: Object, required: true},
        jornadas: { type: Array, required: true},
        agendamento: { type: Object, required: true },
        cota: { type: Object, required: true },
        vagas: { type: Array, required: true },
        horarioAgendamento: { type: String, deafult: null },
        verificaAutorizacao: { type: Boolean, default: false },
        regulacaoSolicitacao: { type: Object },
    },
    watch: {
        'cota': function () {

            if (this.agendamento.data
                && this.agendamento.data !== this.itemSelecionado.data.split("/").reverse().join("-")) {

                    this.handleAlterCota()
            }
        },
        'horario': function (value) {

            if (value) {

                this.handleHorario(this.horariosDisponiveis)
            }
        },
    }
}
</script>

